import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PAYMENT_FLOWS_QUERY_KEY} from "../queryKeys";
import {PaymentFlow, PaymentFlowUpdatePayload} from "./types";

type UpdatePaymentFlowVariables = {id: number; payload: PaymentFlowUpdatePayload};

const updatePaymentFlow = async ({id, payload}: UpdatePaymentFlowVariables): Promise<PaymentFlow> => {
  const response = await axiosReachInstance.put<PaymentFlow, AxiosResponse<PaymentFlow>, PaymentFlowUpdatePayload>(
    `/payment_flows/${id}`,
    payload
  );
  return response.data;
};

export const useUpdatePaymentFlow = (
  options?: BaseMutationOptions<PaymentFlow, UpdatePaymentFlowVariables>
): BaseUseMutationResult<PaymentFlow, UpdatePaymentFlowVariables> => {
  return useBaseMutation<PaymentFlow, UpdatePaymentFlowVariables>(updatePaymentFlow, {
    ...options,
    prefixKeysToReset: () => [[PAYMENT_FLOWS_QUERY_KEY]],
  });
};
